import React from 'react';

import styled from 'styled-components';

interface ToggleProps {
  isActive: boolean;
  onClick: (isActive: boolean) => void;
}

const ToggleContainer = styled.div`
  display: flex;
  background: #f3f3f3;
  border-radius: 25px;
  width: 100px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent; /* ✅ Removes the flashing effect */
  user-select: none; /* Optional: Prevents text selection */
`;

const ToggleOption = styled.div<{ active: boolean }>`
  flex: 1;
  text-align: center;
  padding: 8px 12px;
  border-radius: 25px;
  font-weight: bold;
  transition: all 0.3s ease;
  background: ${({ active }) =>
    active ? (props) => props.theme.special : 'transparent'};
  color: ${({ active }) => (active ? '#fff' : '#9e9e9e')};
`;

const Toggle: React.FC<ToggleProps> = ({ isActive, onClick }) => {
  return (
    <ToggleContainer>
      <ToggleOption active={isActive} onClick={() => onClick(true)}>
        Yes
      </ToggleOption>
      <ToggleOption active={!isActive} onClick={() => onClick(false)}>
        No
      </ToggleOption>
    </ToggleContainer>
  );
};

export default Toggle;
